import React, { createContext, useCallback, useContext, useEffect, useState, } from 'react' 
import useDelayShow from '../../hooks/useDelayShow';
import stores from '../../state';
import { isDarkMode } from '../../utils/util';

interface ArticlesContext {
  articles: any[]
  setArticles: ([])=>void;
  followIds: number[];
  setFollowIds: ([])=>void;
  collectIds: number[];
  setCollectIds: ([])=>void;
  excerpt?: string;
  setExcerpt?: (excerpt:string)=>void;
  pageRefreshTime?: string;
  updatePageRefreshTime?: ()=>void;
  syncProgress: number;
  setSyncProgress:(progress:number)=>void;
}

export const Context = createContext<ArticlesContext>({
  articles: [],
  setArticles:()=>null,
  followIds: [],
  setFollowIds: ()=>null,
  collectIds: [],
  setCollectIds: ()=>null,
  syncProgress:0,
  setSyncProgress:()=>null
})

export const useFollowIds = () => useContext(Context).followIds
export const useSetFollowIds = () => useContext(Context).setFollowIds

export const useCollectIds = () => useContext(Context).collectIds
export const useSetCollectIds = () => useContext(Context).setCollectIds 
export const usePageRefreshTime = ()=>{
  const {pageRefreshTime,updatePageRefreshTime} = useContext(Context)
  return {pageRefreshTime,updatePageRefreshTime}
}

export const useExcerpt = () => ({
  excerpt:useContext(Context).excerpt,
  setExcerpt:useContext(Context).setExcerpt})

const Articles: React.FC = ({ children }) => { 
  const [articles, setArticles] = useState([])
  const [followIds, setFollowIds] = useState([])
  const [syncProgress, setSyncProgress] = useState(0)
  const [collectIds, setCollectIds] = useState([])
  const [excerpt, setExcerpt] = useState('')
  const [pageRefreshTime,setPageRefreshTime] = useState('')
  const [darkMode,setDarkMode] = useState(false)
  const updatePageRefreshTime = useCallback(()=>{
    setPageRefreshTime(new Date().getTime()+'')
  },[])
  const show = useDelayShow()
  useEffect(()=>{
    // document.getElementsByTagName('body')[0].style.cssText = `background: red !important`;
    if(show){
     updatePageRefreshTime()
      // setThemeColor(stores.TodoList.themeColorStyle)
      // window.addEventListener('change',event=>{
      //   console.log(new Date(),'changed')
      //   // 判断当前的颜色状态
      //   // 触发页面刷新
      //   updatePageRefreshTime()
      //   // document.getElementsByTagName('body')[0].style.cssText = `background: ${isDarkMode()? 'black':'white'} !important`;
      // })
      const mql = window.matchMedia("(prefers-color-scheme: dark)")
      if(mql.addEventListener){
        mql.addEventListener("change",   e => {
          console.log(new Date(),'addEventListener changed')
          updatePageRefreshTime()
        } );
      }else{
        // @ts-ignore
        mql.addListener(()=>{
          console.log(new Date(),'addListener changed')
          updatePageRefreshTime()
        })
      }
    }
    
  },[show])

  useEffect(()=>{
    document.getElementsByTagName('body')[0].style.cssText = `background: ${isDarkMode()? 'black':'white'} !important;`;
    setDarkMode(isDarkMode())
    // filter: ${isDarkMode()? 'brightness(.5)':'brightness(1)'} !important
    // document.getElementsByTagName('body')[0].style.cssText = `filter: ${isDarkMode()? 'brightness(.5)':'brightness(1)'} !important`;
    console.log('article pageRefreshTime',pageRefreshTime,isDarkMode())
  },[pageRefreshTime])
  
  return (
    <Context.Provider value={{
      articles,
      setArticles,
      setFollowIds,
      followIds,
      collectIds,
      setCollectIds,
      excerpt,
      setExcerpt,
      pageRefreshTime,
      updatePageRefreshTime,
      syncProgress,
      setSyncProgress
    }}> 
      {children}
      {darkMode&&<div style={{position:'fixed',left:0,right:0,top:0,bottom:-200,zIndex:Number.MAX_SAFE_INTEGER,background:'#1118',pointerEvents:'none'}}/>}
    </Context.Provider>
  )
}
 

export default Articles